import { addDays, addYears, isAfter, startOfDay } from 'date-fns';
export function getDateRange(now, effectiveDate) {
  const minDate = effectiveDate && isAfter(effectiveDate, now) ? startOfDay(effectiveDate) : startOfDay(addDays(now, 1));
  const maxDate = startOfDay(addYears(now, 4));
  return {
    minDate,
    maxDate
  };
}
export function getAmountOptions(periodType) {
  switch (periodType) {
    case 'days':
      return Array.from({
        length: 90
      }, (_, i) => i + 1);
    case 'weeks':
      return Array.from({
        length: 12
      }, (_, i) => i + 1);
    case 'months':
      return Array.from({
        length: 36
      }, (_, i) => i + 1);
    case 'years':
      return Array.from({
        length: 4
      }, (_, i) => i + 1);
    default:
      return [];
  }
}
export const PERIOD_OPTIONS = ['days', 'weeks', 'months', 'years'];